module.exports = __webpack_public_path__ + "static/IE-stocks-259c3f28142670aacb8aa4f23cb3fabe.png";